import React, { Component } from 'react';
import { Modal, Button } from 'antd';
import Efficiency from '../../sumTotal/Efficiency';

class EfficiencyTotal extends Component {
    state = {
        visible: false,
    }

    show = (crcUserId) => {
        this.setState({
            crcUserId,
            visible: true,
        });
    }

    hide = () => {
        this.setState({ visible: false });
    }

    render() {
        const { visible, crcUserId } = this.state;
        return (
            <Modal
                title="效率统计"
                visible={visible}
                onCancel={this.hide}
                className="preview-modal"
                wrapClassName="vertical-center-modal"
                width="900px"
                maskClosable={false}
                footer={<Button key="back" type="ghost" onClick={this.hide}>关闭</Button>}
            >
                <div style={{ padding: 20 }}><Efficiency visible={visible} crcUserId={crcUserId} type="PERSONAL_EFFICIENCY" /></div>
            </Modal>
        );
    }
}

export default EfficiencyTotal;


// WEBPACK FOOTER //
// ./src/components/user/userEfficiency/EfficiencyTotal.js